import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  OnInit,
  signal,
  Type,
} from '@angular/core';
import { NavComponent } from '../nav/nav.component';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { CircularLoaderService } from '../../services/circularLoader/circular-loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalService } from '../../services/modal/modal.service';
import { ModalAttributes } from '../../../shared/utils/app.const';
import { ConfirmationModalComponent } from '../../../shared/components/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalService } from '../../services/confirmationModal/confirmation-modal.service';
import { VideoPlayerService } from '../../../shared/services/video-player.service';
import { LocalstorageService } from '../../services/essentials/localstorage.service';
import { Cookies, JobNoLocalStorage } from '../../../shared/enums/app.enums';
import { ModalContainerComponent } from '../../../shared/components/modal-container/modal-container.component';
import { FooterComponent } from "../footer/footer.component";
import { NgClass } from '@angular/common';
import { Toaster } from "../../../shared/components/toaster/toaster";
import { ToasterService } from '../../../shared/services/toaster.service';
import { CookieService } from '../../services/cookie/cookie.service';
import { ProfileCompletion } from "../../../features/home/components/profile-completion/profile-completion";
import { InvitationBanner } from "../../../features/home/components/invitation-banner/invitation-banner";
import { ProfileCompletionService } from '../../../features/home/services/profile-completion.service';


@Component({
  selector: 'app-layout',
  imports: [
    RouterOutlet,
    NavComponent,
    ModalContainerComponent,
    ConfirmationModalComponent,
    FooterComponent,
    NgClass,
    Toaster,
    ProfileCompletion,
    InvitationBanner,
],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnInit {
  private circularLoaderService = inject(CircularLoaderService);
  private destroy$ = inject(DestroyRef);
  private modalService = inject(ModalService);
  private route = inject(ActivatedRoute)
  private destroyRef = inject(DestroyRef)
  private confirmationModalService = inject(ConfirmationModalService);
  private videoPlayerService = inject(VideoPlayerService);
  private cookieService = inject(CookieService)
  private router = inject(Router)
  toaster = inject(ToasterService)
  private profileCompletionService = inject(ProfileCompletionService)
  jobNo: string='';
  link: string='';
  isLoading = signal<boolean>(false);
  selectedComponent = signal<Type<any>>(null as any);
  modalAttributes = signal<Record<string, string | boolean>>(ModalAttributes);
  inputs = signal<Record<string, any>>({});
  isEnableMessage = signal<boolean>(false);
  isEnableConfirmation = signal<boolean>(false);
  getModalTitle = signal<string>('');
  getModalContent = signal<string>('');
  isOpen = signal<boolean>(false);
  getOpenButtonText = signal<string>('');
  getCloseButtonText = signal<string>('');
  getSaveButtonText = signal<string>('');
  isClose = signal<boolean>(false);
  showlivebtn:boolean=false;
  examlevel:number=0;
  isPNPLJob=signal<boolean>(false);
  selectedIndex=1;
  isCorporate = signal(false)
  isTopSectionReady = signal(false);
  priceList= [
    { text: 'Unlock All Contacts', value: 5145 },
    { text: 'Unlocked 5 Contacts', value: 1040 },
    { text: 'Unlocked 10 Contacts', value: 1575 },
    { text: 'Unlocked 15 Contacts', value: 1995 },
    { text: 'Unlocked 20 Contacts', value: 2615 },
  ];
  isPricingSectionVisible=true;
  purchase='You haven’t purchased yet.';

  hideTopSection = signal(false);

  readonly isAuthenticated = computed(() => {
    const userId = this.cookieService.getCookie(Cookies.MYBDJOBSGID);
    return userId !== null && userId !== '';
  });

  shouldShowTopSection = computed(() => {
    return this.isAuthenticated() && !this.hideTopSection();
  });

  constructor(private localStorageService: LocalstorageService) {
    this.jobNo = this.localStorageService.getItem(JobNoLocalStorage);
    this.link = `https://corporate3.bdjobs.com/onlinetest-dashboard.asp?jobno=${this.jobNo}&pgLevelType=${this.examlevel}`;
    this.updateProfileCompletionVisibility();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isTopSectionReady.set(false);
      }

      if (event instanceof NavigationEnd) {
        this.updateProfileCompletionVisibility();
      }
    });
  }

  isProfileCompletionLoading = this.profileCompletionService.isProfileCompletionLoading;
  ngOnInit() {
    this.listenOnLoading();
    this.listenOnModal();
    this.listenConfirmationModal();
    this.onClickPriceList();

    this.route.queryParams
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(params => {
      if (params['src'] === 'recruiter.bdjobs.com') {
           this.isCorporate.set(true);
      }
    });
  }

  private listenOnLoading() {
    this.circularLoaderService.loadingState$
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe((loading) => {
        this.isLoading.update(() => loading);
      });
  }

  private listenOnModal() {
    this.modalService.modalConfig$
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe((config) => {
        if (config.isClose) {
          this.isClose.update(() => true);
        } else if (config.componentRef) {
          this.selectedComponent.update(() => config.componentRef);
          this.modalAttributes.update(() => config.attributes);
          this.inputs.update(() => (config.inputs ? config.inputs : {}));
        }
      });
  }

  onCloseEvent(event: boolean) {
    this.selectedComponent.update(() => null as any);
    if (event) {
      this.isClose.update(() => false);
    }
    this.modalService.onCloseModalSubject.next(true);
    this.inputs.update(() => ({}));
    this.videoPlayerService.resetVideoPlayerStatus()
  }

  private listenConfirmationModal() {
    this.confirmationModalService.modalConfig$
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe((config) => {
        this.isEnableConfirmation.update(() => config.isOpen ?? false);
      });
  }

  private updateProfileCompletionVisibility(): void {
    let route: ActivatedRoute | null = this.route;
    let shouldHide = false;
    while (route !== null) {
      if (route.snapshot.data['hideTopSection'] === true) {
        shouldHide = true;
        break;
      }

      route = route.firstChild;
    }

    this.hideTopSection.set(shouldHide);
    this.isTopSectionReady.set(true);
  }

  toggleModal(event: boolean): void {
    this.isOpen.set(event);
  }
  saveChanges(event: boolean): void {
    this.isOpen.set(event);
  }

  onClickPriceList() {
    this.isPricingSectionVisible = false;
  }
  onClickStat(){
    this.isPricingSectionVisible = true;
    this.purchase="You haven’t purchased yet."
  }

  onRadioChange(index: number): void {
    this.selectedIndex = index;
  }

}
